import { useEffect } from 'react';
import { updateUniNavUrls } from '@alchemer/universal-navigation/nav';
import { useBoundStore } from '@/store';
import { useAppPermissions } from '@/api/queries/useSdkTokenQuery';
import { useProductUrls } from '@/hooks/useProductUrls';

/**
 * Syncs universal navigation URLs with current selected region
 * Updates navigation links whenever the selected region or app permissions change
 */
export function useUniversalNavSync() {
  const selectedRegion = useBoundStore((state) => state.selectedRegion);
  const appPermissions = useAppPermissions();
  const productUrls = useProductUrls();

  useEffect(() => {
    const navContainer = document.getElementById('uniNavContainer');
    if (!navContainer) {
      return;
    }

    if (!appPermissions) return;

    updateUniNavUrls(productUrls);

    console.log('[UniNav] URLs updated for region:', selectedRegion, productUrls);
  }, [selectedRegion, appPermissions, productUrls]);
}
